export default Object.freeze({
  V1: 1,
  V2: 2,
});
